query AssignationSessionsPreview(
  $scenarioId: ID!
  $originId: ID!
  $input: AssignationSessionsPreviewInput!
) {
  cube(scenarioId: $scenarioId, originId: $originId) {
    assignationSessionsPreview(input: $input) {
      sections {
        id
        courseComponent {
          id
          component {
            id
            code
            name
          }
        }
        sessions {
          id
          blocksCount
          originSessionIds
          newInstancesCount
          isPreview
          classrooms {
            id
            code
            name
            classroomType {
              id
              code
              name
            }
            building {
              id
              code
              name
              campus {
                id
                code
                name
              }
            }
            floor
            usable
          }
          instructors {
            id
            code
            name
          }
          assignment {
            day
            blocks {
              id
              day
              startingTime
              endingTime
            }
            intervals {
              id
              name
              startingDate
              endingDate
            }
            blockRange {
              start {
                id
                day
                startingTime
                endingTime
              }
              end {
                id
                day
                startingTime
                endingTime
              }
            }
          }
        }
      }
      validationErrors {
        code
        message
      }
    }
  }
}
